import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { galleryService } from '../../../services/GalleryService';
import { galleryQueryKeys } from '../galleryQueryKeys';

export function useGalleryImageDataQuery(
  imageId: string,
  options?: { enabled?: boolean },
) {
  const { user } = useAuth();
  const isEnabled =
    (options?.enabled ?? true) && Boolean(user) && imageId.length > 0;

  return useQuery({
    queryKey: galleryQueryKeys.imageData(imageId),
    enabled: isEnabled,
    // Keep while browsing; drop unused blobs after the gallery page unmounts.
    staleTime: Infinity,
    gcTime: 1000 * 60 * 10,
    queryFn: () => galleryService.downloadImageData(imageId),
  });
}
